
import { useContext, ref, useRoute, useAsync, computed } from '@nuxtjs/composition-api';
import useFamilySubscription from '@/composable/useFamilySubscription';
import useUtilities from '@/composable/useUtilities';
import useShoppingList from '@/composable/useShoppingList';
import useTlmCart from '@/composable/useTlmCart';
import useTracking from '~/composable/tracking/useTracking'
export default {
  setup() {
    const route = useRoute()
    const channelSplit = route.value.query.channelsplit
    let selectedMixServices = route.value.query.tlmmix
    selectedMixServices = selectedMixServices !== undefined ? selectedMixServices?.split(',') : selectedMixServices
    const { app } = useContext()
    const familySubscription = ref(null)
    const subscriptionId = route.value.params.subscriptionid
    // const showWishlist = ref(false)
    const modelMaxSubscriptionsReached = ref(false)
    const totalSubscriptions = ref(0)
    const max = 5



    const { getChildSubscriptionsForFamilySubscription } = useFamilySubscription(app.$hubble)
    const { calculateDataCap, voiceCap, roamingDataCap, smsAndMmsCap, isFiveG } = useUtilities()
    const { track } = useTracking()
    const trackData = ({ interactionLabel, interactionComponent }) => {
      track('familyConcept', { interactionLabel, interactionComponent })
    }
    const {
      createShoppingList,
      shoppingList,
      addShoppingListItem,
      updateShoppingList,
      getCounterVal,
      buySubscriptionWithoutFamilyConcept,
      getDisplayPerMonthPrice,
      buyFamilySubscription
    } = useShoppingList(app)

    const { loadOrCreateCart } = useTlmCart(app);
    useAsync(async () => {
      familySubscription.value = await getChildSubscriptionsForFamilySubscription(subscriptionId)
      await createShoppingList()
      await addShoppingListItem(shoppingList.value.id, familySubscription?.value?.parentSubscription?.bundleName, 1)
      await loadOrCreateCart()
    }, 'familieabonnement')

    const shouldOpenMaxReachedNotification = ref(false)
    const counters = ref({})

    const isUpdating = ref(false); // Add this line

    // eslint-disable-next-line complexity
    const onCounterChange = async ({ event, channelKey }) => {
      if (isUpdating.value) { return; } // Prevent multiple calls
      isUpdating.value = channelKey; // Set flag to true when starting the update

      if (event.event === 'up' && shouldOpenMaxReachedNotification.value) {
        modelMaxSubscriptionsReached.value = true;
        isUpdating.value = false; // Reset flag
        return;
      }

      if (event.event === 'down' && counters.value[channelKey] === 0) {
        isUpdating.value = false; // Reset flag
        return;
      }

      shouldOpenMaxReachedNotification.value = false;

      const val = event.event === 'up' ? 1 : -1;
      const newVal = counters.value[channelKey] + val;
      const quantity = newVal > 0 ? newVal : 0;



      try {
        await updateShoppingList(shoppingList.value.id, channelKey, quantity);
        counters.value[channelKey] = quantity;
        totalSubscriptions.value = Object.values(counters.value).reduce((accumulator, currentValue) => accumulator + currentValue, 0);
        if (totalSubscriptions.value >= max) {
          shouldOpenMaxReachedNotification.value = true;
        }
      } catch (err) {
        console.error(err);
      } finally {
        isUpdating.value = false; // Reset flag after the update is complete
        bounceIt();
      }
      trackData({ interactionLabel: (event.event === 'up' ? 'Add ' : 'Subtract ') + quantity, interactionComponent: channelKey })
    };


    const bounce = ref(false)

    function bounceIt() {
      bounce.value = true
      setTimeout(() => {
        bounce.value = false
      }, 900)
    }

    const showShoppingList = ref(false)

    const dataCap = (subscription) => {
      const data = calculateDataCap(subscription)
      return data >= 1000 ? 'Fri Data' : data + ' GB'
    }

    const childSubscriptionOptions = computed(() => {
      familySubscription?.value?.childSubscriptionOptions?.forEach(item => {
        counters.value[item.channelKey] = 0
      })
      return familySubscription?.value?.childSubscriptionOptions
    })
    return {
      isFiveG,
      subscriptionId,
      channelSplit,
      selectedMixServices,
      isUpdating,
      counters,
      trackData,
      buyFamilySubscription,
      modelMaxSubscriptionsReached,
      getDisplayPerMonthPrice,
      buySubscriptionWithoutFamilyConcept,
      getCounterVal,
      bounce,
      smsAndMmsCap,
      roamingDataCap,
      voiceCap,
      dataCap,
      childSubscriptionOptions,
      familySubscription,
      showShoppingList,
      max,
      totalSubscriptions,
      onCounterChange
    }
  },
  head () {
    return {
      meta: [
        {
          hid: 'robots',
          name: 'robots',
          content: 'noindex, nofollow'
        }
      ]
    }
  }
}
